import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import BookSpeaking from "./pages/BookSpeaking";
import Admin from "./pages/Admin";
import Resources from "./pages/Resources";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book-speaking" element={<BookSpeaking />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
